import React from "react";

type Props = { message?: string; children?: JSX.Element };

const ErrorMessageContainer = ({ message, children }: Props) => {
  return (
    <div className="p-2 rounded-xl bg-red-200 text-red-900">
      {message}
      {children}
    </div>
  );
};

export default ErrorMessageContainer;
